import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { AssociationEntityState } from '@_model/interfaces/association.model';

export interface AssociationState extends EntityState<AssociationEntityState> {
  isLoaded: boolean;
  isLoading: boolean;
  actives: number[];
}

export const adapter: EntityAdapter<AssociationEntityState> = createEntityAdapter<AssociationEntityState>({
  selectId: o => o.idAssociation
});
export const initialState: AssociationState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const associationFeatureKey = 'association';
